import { atom } from "recoil";

export const userState = atom({
  key: "user",
  default: null,
});

export const userAuthState = atom({
  key: "userAuth",
  default: null,
  dangerouslyAllowMutability: true,
});

export const clientIdState = atom({
  key: "clientId",
  default: null,
});

export const editUserState = atom({
  key: "editUser",
  default: null,
});

export const userMicState = atom({
  key: "userMicState",
  default: "off",
});

export const userNotificationState = atom({
  key: "userNotifications",
  default: [],
});

export const activityState = atom({
  key: "activityState",
  default: [],
});

export const actionPrivateNotesState = atom({
  key: "actionPrivateNotes",
  default: { notes: "" },
});

export const crudState = atom({
  key: "crud",
  default: {
    create: true,
    update: true,
    delete: true,
    approve: true,
    chat: true,
    admin: false,
    boardsAccess: false,
    workflowsAccess: false,
  },
});

export const loggedOutState = atom({
  key: "socketLoggedOut",
  default: null,
});

export const boardMemberSignatureState = atom({
  key: "boardMemberSignature",
  default: null,
});
